import {
  ActionEmptyState,
  Button,
  Card,
  CardContent,
  Typography,
} from "@/components/ui";
import { NotificationItems } from "@/components/ui/NotificationItems/NotificationItems";
import { getNotificationInboxItemsOptions } from "@/lib/data/react-query";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { Bell, BellOff } from "lucide-react";
import orderBy from "lodash/orderBy";
import { uniqBy } from "lodash";

export const DashboardNotificationsCard = () => {
  const { data, isLoading, error } = useQuery(
    getNotificationInboxItemsOptions(),
  );
  const notifications = data?.data.notifications || [];
  const unreadCount = data?.data.unreadCount ?? 0;

  const sortedNotifications = orderBy(
    notifications,
    [(e) => e.dateCreated],
    ["desc"],
  );
  const uniqueNotifications = uniqBy(sortedNotifications, (event) => event.id);
  const formattedUnreadCount = unreadCount > 99 ? "99+" : unreadCount;

  return (
    <Card className="w-full">
      <CardContent className="p-4">
        <div className="mb-4 flex items-center gap-2">
          <Bell className="h-5 w-5" />
          <Typography variant="heading">Notifications</Typography>
          {unreadCount > 0 && (
            <Typography variant="subHeading" className="text-muted-foreground">
              {!isLoading && !error && `(${formattedUnreadCount})`}
            </Typography>
          )}
        </div>

        <div className="max-h-96 space-y-3 overflow-y-auto px-2">
          {!isLoading && !error && uniqueNotifications.length === 0 ? (
            <ActionEmptyState
              icon={<BellOff className="h-5 w-5" />}
              title="No notifications yet"
              description="Notifications will appear here when work is updated across the app."
              actions={
                <>
                  <Button asChild size="sm">
                    <Link to="/matters">View matters</Link>
                  </Button>
                  <Button asChild size="sm" variant="outline">
                    <Link to="/profile">Review preferences</Link>
                  </Button>
                </>
              }
            />
          ) : (
            <NotificationItems />
          )}
        </div>
      </CardContent>
    </Card>
  );
};
